export class ImageCountService
{

	public async getImageCount(): Promise<any>
	{
		const response = await fetch("/api/imagecount");
		return await response.json();
	}
}